import { Scene, Input, Math } from "phaser";
import {
    backStaticAnimation, leftStaticAnimation, lightstickAnimation, mapHandler, reposeAnimation,
    rightStaticAnimation, turnStaticAnimation, upStaticAnimation, walkAnimation
} from '../../phaser/create';
import { walkHandler, directionHandler, randomDirection, setLastMovement } from '../../phaser/update';
import FullScreen from "../../phaser/components/fullScreen";
import PauseButton from "../../phaser/components/pauseButton";
import LightstickCounter from "../../phaser/components/lightstickCounter";
import ButtonPressed from "../../phaser/components/buttonPressed";
import SettingsButton from "../../phaser/components/settingsButton";
import HelpButton from "../../phaser/components/helpButton";
import Joystick from "../../phaser/components/joystick";

let cursors;
let walls;
let instructionsHandler = 0;

let characterSelected;
let objNames = {};
let timeoutDoor = {};
let footsteps;
let speedEnemy = 100;
let hearts = 2;
let totalHearts = 2;
let redHeartsObject = [];
let blackHeartsObject = [];
let gameSettings;
let defaultSettings = 1;
let lastCoordenates = null;
let totalTimer = 30;

export default class Game3 extends Scene {

    constructor() {
        super({ key: "Game3" });
    }
    init(data) {
        characterSelected = data.characterSelected;
        lastCoordenates = data.lastCoordenates;
        this.hasLightstick = false;
        speedEnemy = 100;
        redHeartsObject = [];
        blackHeartsObject = [];
        hearts = 2;
        this.events.off('buttonNext-dialogModal');
        this.events.off('pause-event');
        this.startAll = false;
        setLastMovement('down');
        clearInterval(this.countdown);
        totalTimer = 30;
        this.isPause = false;
    }

    preload() {
        if (this.sys.game.device.os.desktop) {
            console.log("desktop")
            this.isMobile = false;
        }
        else {
            this.isMobile = true;

            console.log("mobile")
        }
        cursors = this.input.keyboard.createCursorKeys();
    }

    create() {

        this.spaceBar = this.input.keyboard.addKey(Input.Keyboard.KeyCodes.SPACE);
        this.pauseButton = this.input.keyboard.addKey(Input.Keyboard.KeyCodes.P);
        this.dialogModal = this.plugins.get('dialogModal');

        gameSettings = localStorage.getItem('sound');
        if (gameSettings === null) {
            localStorage.setItem('sound', 1);
            gameSettings = defaultSettings;
        }

        this.events.on('pause', () => {
            if(this.joystickManager) {
                this.joystickManager.pause();
            }
            this.isPause = true;
            this.startAll = false;
        });

        this.events.on(`resume`, (data, args) => {
            this.isPause = false;
            this.sound.mute = false;
            if (args) {
                footsteps.stop();
                this.ppalSong.stop();
                this.scene.stop();
                this.events.off('pause-event');

                if (args.goHome) {
                    if(this.joystickManager) {
                        this.joystickManager.destroyTest();
                        this.joystickManager = null;
                    }
                    this.events.off('buttonNext-dialogModal');

                    this.scene.start(`Hallway`, { characterSelected: characterSelected, loadAgain: true, lastCoordenates });
                }

                if (args.goStart) {

                    if(this.joystickManager) {
                        this.joystickManager.destroyTest();
                        this.joystickManager = null;
                    }
                    this.events.off('buttonNext-dialogModal');

                    this.scene.start(`Start`);
                }
            } else {

                if(!this.showingInstruction) {
                    this.startAll = true;
                }

                if(this.isMobile) {
                    if(this.joystickManager) {
                        this.joystickManager.show();
                    }
                }

                gameSettings = localStorage.getItem('sound');
                if (gameSettings === '0') {
                    if (this.ppalSong.isPlaying) {
                        this.ppalSong.stop()
                    }
                } else {
                    if (!this.ppalSong.isPlaying) {
                        this.ppalSong.play();
                    }
                }
            }
        });

        this.cameras.main.setBounds(0, 0, 900);
        this.physics.world.setBounds(0, 0, 900);

        this.ppalSong = this.sound.add(`flyhighSong`, { loop: true, volume: 0.2 });
        if (gameSettings === '1') {
            this.ppalSong.play();
        }
        this.map = mapHandler(this, 'game3', true, 8, 8);

        footsteps = this.sound.add(`footsteps`, { loop: true, rate: 2, volume: 0.2 });

        this.playing = false;
        walls = this.map.walls;
        walls.setScale(3);
        this.map.ground.setScale(3);
        this.door = this.map.map.createLayer('Door', this.map.tileset, 0, 0);
        this.door.setCollisionByProperty({ collides: true });
        this.door.setScale(3);

        this.lightstick = this.map.map.createLayer('Lightstick', this.map.tileset, 0, 0);
        this.lightstick.setScale(3);
        this.lightstick.visible = false;

        this.anims.create({
            key: `plant-move`,
            frames: this.anims.generateFrameNumbers(`plant`, { start: 0, end: 3 }),
            frameRate: 7,
            repeat: -1
        });

        // INICIO ANIMIACION INDIVIDUAL DE SPRITE
        // this.plantExample = this.physics.add.sprite(450, 3550, 'plant');
        // this.plantExample.anims.play(`plant-move`, true);
        // FIN ANIMACIONES EN GRUPO DEL MISMO OBJETO


        // INICIO ANIMACIONES EN GRUPO DE MISMO SPRITE DEL MISMO OBJETO
        // this.gameitems = this.physics.add.group();

        // this.anims.create({
        //     key: `plant-move`,
        //     frames: this.anims.generateFrameNumbers(`plant`, { start: 0, end: 3 }),
        //     frameRate: 7,
        //     repeat: -1
        // });

        // for (var i = 0; i < 20; i++) {
        //     var x1 = Math.RND.between(80, 340); // AQUI LE INDICAS RANGO EN DONDE QUIERES QUE APAREZCAN EL SPRITE EN X
        //     var y2 = Math.RND.between(2245, 3600); // AQUI LE INDICAS RANGO EN DONDE QUIERES QUE APAREZCAN EL SPRITE EN Y

        //     const test = this.gameitems.create(x1, y2, 'plant');
        //     test.anims.play(`plant-move`, true);

        // }
        // FIN ANIMACIONES EN GRUPO DEL MISMO OBJETO


        this.object = this.map.map.createLayer('Objects', this.map.tileset, 0, 0);
        this.object.setCollisionByProperty({ collides: true });

        this.object.setScale(3);

        objNames[characterSelected] = this.physics.add.sprite(450, 3550, `${characterSelected}-game3`, 4);
        objNames[characterSelected].setScale(2.5);
        objNames[characterSelected].setImmovable();

        this.enemy = this.physics.add.sprite(Math.Between(56, 832), Math.Between(210, 1996), `enemy-game3`);
        this.enemy.setImmovable();

        walkAnimation(this, `${characterSelected}-game3`);
        reposeAnimation(this, `${characterSelected}-game3`);
        turnStaticAnimation(this, `${characterSelected}-game3`);
        upStaticAnimation(this, `${characterSelected}-game3`);
        leftStaticAnimation(this, `${characterSelected}-game3`);
        rightStaticAnimation(this, `${characterSelected}-game3`);
        backStaticAnimation(this, `${characterSelected}-game3`);
        lightstickAnimation(this, `${characterSelected}-game3`);


        walkAnimation(this, `enemy-game3`, true);
        turnStaticAnimation(this, `enemy-game3`, 1);
        upStaticAnimation(this, `enemy-game3`, 10);
        leftStaticAnimation(this, `enemy-game3`, 4);
        rightStaticAnimation(this, `enemy-game3`, 7);
        backStaticAnimation(this, `enemy-game3`, 11);


        this.physics.add.collider(objNames[characterSelected], walls);
        this.physics.add.collider(this.enemy, walls, () => {
            randomDirection(`enemy-game3`);
        }, null, this);
        this.physics.add.collider(this.enemy, this.object, () => {
            randomDirection(`enemy-game3`);
        }, null, this);
        this.physics.add.collider(this.enemy, this.door, () => {
            randomDirection(`enemy-game3`);
        }, null, this);
        this.physics.add.collider(this.enemy, objNames[characterSelected], () => {

            // if(this.joystickManager) {
            //     this.joystickManager.pause();
            //     // this.joystickManager = null;
            // }
            this.enemy.destroy();
            clearInterval(this.countdown);
            this.countdownText.destroy();

            this.lightstick.visible = true;

            this.startAll = false;
            objNames[characterSelected].setVelocity(0, 0);
            objNames[characterSelected].anims.play(`repose-${characterSelected}-game3`);
            this.showingInstruction = true;
            this.dialogModal._createImageDialog(this, 'middle-text');
            this.dialogModal.setText("I caught it! \nAlthough it doesn't seem like a normal spider... \nI'll leave it locked up in a jar. Now I have to find my lightstick.".toUpperCase(), `${characterSelected}-hallway`, false, false)
            setTimeout(() => {
                this.dialogEnemyVisible = true;
            }, 1000);

        }, null, this);

        this.physics.add.collider(objNames[characterSelected], this.object);
        this.physics.add.collider(this.enemy, this.object);
        this.physics.add.collider(objNames[characterSelected], this.door, () => {
            clearTimeout(timeoutDoor);
            timeoutDoor = setTimeout(() => {
                if (this.hasLightstick) {
                    let total = JSON.parse(localStorage.getItem('noL'));
                    if (total) {
                        if (!total.includes(3)) {
                            total.push(3);
                            localStorage.setItem('noL', JSON.stringify(total));

                        }
                    } else {
                        localStorage.setItem('noL', JSON.stringify([3]));
                    }

                    this.cameras.main.fade(1000, 0, 0, 0, false, (cam, progress) => {
                        if (progress === 1) {
                            footsteps.stop();
                            this.ppalSong.stop();
                            this.scene.stop();
                            if(this.joystickManager) {
                                this.joystickManager.destroyTest();
                                this.joystickManager = null;
                            }
                            this.events.off('buttonNext-dialogModal');
                            this.events.off('pause-event');


                            this.scene.start(`Win`, { characterSelected: characterSelected, level: 3, lastCoordenates });
                        }
                    });

                }
            }, 1000);
        }, null, this);

        this.time.addEvent({
            delay: 3000,
            callback: () => {
                randomDirection(`enemy-game3`);
            },
            loop: true
        })

        this.time.addEvent({
            delay: 10000,
            callback: () => {
                if (speedEnemy < 500) {
                    speedEnemy += 20;
                }
            },
            loop: true
        })

        this.cameras.main.startFollow(objNames[characterSelected], true);

        this.buttonFullscreen = new FullScreen(this);
        this.buttonSettings = new SettingsButton(this);
        this.buttonPause = new PauseButton(this, characterSelected);
        this.buttonHelp = new HelpButton(this);


        window.addEventListener("blur", () => {
            this.isPause = true;
            this.buttonPause.pauseByEvent();
         });
     
        //  document.addEventListener('visibilitychange', () => {
        //      if (document.visibilityState !== 'visible') {
        //          this.buttonPause.pauseByEvent();
        //  } 
        //  });

        this.events.on('buttonNext-dialogModal', (data) => {

            instructionsHandler++;
            if (data.id === 'start-text') {
                if (instructionsHandler === 1) {
                    this.dialogModal.close();
                    instructionsHandler = 0;
                    this.startAll = true;
                    this.showingInstruction = false;
                    this.countdownText.visible = true;

                    if(this.isMobile) {
                        this.joystickManager = new Joystick(objNames[characterSelected], `${characterSelected}-game3`, 300);
                        this.joystickManager.createJoystick();
                        this.joystickManager.activate(this.hasLightstick);

                    }

                    this.countdown = setInterval(() => {
                        if (!this.isPause) {
                            totalTimer--;
                        }
            
                        if (totalTimer <= 0) {
                            clearInterval(this.countdown);
                            this.updateCounter();
                        }
                    }, 1000);
            
                }
            }
            if (data.id === 'middle-text') {

                if (instructionsHandler === 1) {
                    this.dialogModal.close();
                    instructionsHandler = 0;
                    this.startAll = true;
                    this.showingInstruction = false;
                }

            }

            if (data.id === 'finish-text') {
                if (instructionsHandler === 1) {
                    this.dialogModal.close();
                    instructionsHandler = 0;
                    this.startAll = true;
                    this.showingInstruction = false;

                }
            }
        })


        objNames[characterSelected].anims.play(`repose-${characterSelected}-game3`);
        this.showingInstruction = true;
        this.dialogModal._createImageDialog(this, 'start-text');
        
        this.dialogModal.setText("I think I saw a spider... \nsomething tells me I have to catch it before it escapes...".toUpperCase(), `${characterSelected}-hallway`, false, false);

        if (this.isMobile) {
            this.buttonAction = new ButtonPressed(this, 700, 500 - 51, `buttonAction`);
            this.buttonAction.setScale(2);
            this.add.existing(this.buttonAction);
        }

        let x = 0;
        let y = 16;
        for (let i = 0; i < totalHearts; i++) {
            if (i === 0) {
                x += 40;
            } else {
                x += 30;
            }
            blackHeartsObject.push(this.add.image(x, y, `heartBlack`, 0).setScale(3).setOrigin(1, 0).setScrollFactor(0));
            redHeartsObject.push(this.add.image(x, y, `heartRed`, 0).setScale(3).setOrigin(1, 0).setScrollFactor(0));
        }

        this.lightstickCounter = new LightstickCounter(this);

        this.countdownText = this.add.bitmapText((this.cameras.main.worldView.x + this.cameras.main.width / 2) + 50, 16, 'pixelfont',`${totalTimer} SEG`.toUpperCase(), 10, 1).setTint(0xFFFFFF).setDepth(1).setOrigin(1, 0).setScrollFactor(0).setScale(1.5).setVisible(false);
        this.helpLightstick = this.add.bitmapText(0, 20, 
            'pixelfont', "Interact: spacebar/action button".toUpperCase(), 10,1).setTint(0xffffff).setOrigin(1, 0).setScale(1).setVisible(false).setScrollFactor(0);


    }

    updateCounter() {
        this.tweens.add({
            targets: redHeartsObject[hearts - 1],
            alpha: 0,
            scaleX: 0,
            scaleY: 0,
            ease: 'Linear',
            duration: 200
        });

        var heartsTimeline = this.tweens.createTimeline();

        heartsTimeline.add({
            targets: blackHeartsObject[hearts - 1],
            scaleX: 1.5,
            scaleY: 1.5,
            ease: 'Power1',
            duration: 200
        });

        heartsTimeline.add({
            targets: blackHeartsObject[hearts - 1],
            scaleX: 3,
            scaleY: 3,
            ease: 'Power1',
            duration: 200
        });
        heartsTimeline.play();
        hearts -= 1;
        setTimeout(() => {
            clearInterval(this.countdown);
            if (hearts <= 0) {
                if(this.joystickManager) {
                    this.joystickManager.destroyTest();
                }
                this.enemy.destroy();
                this.cameras.main.fade(1000, 0, 0, 0, false, (cam, progress) => {
                    if (progress === 1) {
                        footsteps.stop();
                        this.ppalSong.stop();
                        this.scene.stop();
                        this.events.off('buttonNext-dialogModal');
                        this.events.off('pause-event');

                        this.scene.start(`GameOver`, { characterSelected: characterSelected, level: 3, lastCoordenates });
                    }
                });
            } else {
                objNames[characterSelected].clearTint();
                objNames[characterSelected].alpha = 1;
                totalTimer = 30;
                this.countdown = setInterval(() => {
                    if(!this.isPause) {
                        totalTimer--;
                    }
                    if (totalTimer <= 0) {
                        clearInterval(this.countdown);
                        this.updateCounter();
                    }
                }, 1000);

            }

        }, 1000);

    }
    update() {
        this.screenCenterX = (this.cameras.main.worldView.x + this.cameras.main.width / 2) + 50;
        this.screenCenterY = this.cameras.main.worldView.y;

        if (this.startAll) {

            if (!this.isMobile) {
                walkHandler(cursors, objNames[characterSelected], 300, `${characterSelected}-game3`, this.hasLightstick);
            } else {
                if(this.joystickManager) {

                    this.joystickManager.show();
                }
            }

            this.countdownText.setText(`${totalTimer} SEG`);


            if ((!this.isMobile && (cursors.left.isDown || cursors.right.isDown || cursors.up.isDown || cursors.down.isDown))) {
                if (this.playing !== true) {
                    if (gameSettings === '1') {

                        footsteps.play();
                        this.playing = true;
                    }
                }

            } else {
                this.playing = false;
                footsteps.stop();
            }

            if (this.enemy.active) {
                directionHandler(this.enemy, speedEnemy, `enemy-game3`);
            }
        } else {
            if(this.isMobile) {
                if(this.joystickManager) {
                    objNames[characterSelected].setVelocity(0, 0);
                    objNames[characterSelected].anims.play(`repose-${characterSelected}-game3`);
                    this.joystickManager.pause();
                }
            }
        }

        const tile = this.lightstick.getTileAtWorldXY(objNames[characterSelected].x, objNames[characterSelected].y);
        if (tile) {
            if (this.lightstick.visible) {
                this.helpLightstick.setPosition(this.screenCenterX, this.screenCenterY - 20);
                this.helpLightstick.visible = true;
                if ((!this.isMobile && this.spaceBar.isDown) || (this.isMobile && this.buttonAction.isDown)) {

                    this.lightstick.visible = false;
                    this.hasLightstick = true;
                    if(this.isMobile) {
                        this.joystickManager.setLightStickValue(this.hasLightstick);
                    }
                    this.startAll = false;
                    this.showingInstruction = true;
                    objNames[characterSelected].setVelocity(0, 0);
                    this.dialogModal._createImageDialog(this, 'finish-text');
                    this.dialogModal.setText("There are 7 chairs here… \nI need to go back to the exit.".toUpperCase(), `${characterSelected}-hallway`, false, false)
                }
            }
        } else {
            this.helpLightstick.visible = false;
        }

    }

}